module.exports = __webpack_public_path__ + "img/wallet_card3.e7cbb24e.png";